import { IconLock } from "@tabler/icons-react";
import ModalShell from "../../../components/Support/ModalShell";
import Input from "../../UI/FormInput/input";
import styles from "./popup.module.css";
import { fmtCurrency } from "../../../utils/functions";
import Button from "../../UI/Button/button";

const SubPopup = ({
  order,
  onClose,
  defaultEmail = "",
  handlePay,
  loading,
}) => {
  if (!order) return null;

  const { kind, name, credits, price, perCredit, currency } = order;
  const isPack = kind === "topup";
  const kindLabel = isPack ? "Credit Pack" : "Annual Plan";
  const creditsLabel = `${credits} credits${isPack ? "" : " upfront"}`;
  const note = isPack
    ? "Credits never expire · added instantly"
    : "Full year of credits upfront · 12-month rollover";

  return (
    <ModalShell
      open={order}
      onClose={onClose}
      eyebrow={kindLabel}
      title="Order Summary"
    >
      <div className={styles.item}>
        <div>
          <div className={styles.itemNameRow}>
            <span className={styles.itemName}>{name}</span>
            <span className={styles.badge}>{kindLabel}</span>
          </div>
          <div className={styles.itemCredits}>{creditsLabel}</div>
          <div className={styles.itemNote}>{note}</div>
        </div>
        <div className={styles.itemPriceCol}>
          <div className={styles.itemPrice}>{fmtCurrency(price, currency)}</div>
          {perCredit != null && (
            <div className={styles.itemPer}>
              {fmtCurrency(perCredit, currency)}/credit
            </div>
          )}
        </div>
      </div>

      <div className={styles.totals}>
        <div className={styles.row}>
          <span className={styles.lbl}>Subtotal</span>
          <span className={styles.val}>{fmtCurrency(price, currency)}</span>
        </div>
        <div className={styles.row}>
          <span className={styles.lbl}>Billing</span>
          <span className={`${styles.val} ${styles.ok}`}>One-time payment</span>
        </div>
        <div className={`${styles.row} ${styles.grand}`}>
          <span className={styles.lbl}>Total due today</span>
          <span className={styles.val}>{fmtCurrency(price, currency)}</span>
        </div>
      </div>

      {defaultEmail && (
        <Input
          label="Account email"
          htmlFor="checkout-email"
          type="email"
          placeholder="you@company.com"
          value={defaultEmail}
          readonly
        />
      )}

      <Button
        variant="primary"
        fullWidth
        onClick={handlePay}
        loading={loading}
        disabled={loading}
      >
        Pay {fmtCurrency(price, currency)}
      </Button>

      <div className={styles.secure}>
        <IconLock size={14} /> Secure checkout · credits never expire
      </div>
    </ModalShell>
  );
};

export default SubPopup;
